module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic.d159f16e.eot";